const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const COMMUNITY_SEARCH_CONTENT = "/search/content";
const REACT_APP_API_ENDPOINT_CACHED = process.env.REACT_APP_API_ENDPOINT_CACHED;
const COMMUNITY_USER_PROFILE = "/user/profile";
const COMMUNITY_USER_ONBOARDING_SEED = "/user/onboardingSeed";

export default {
    BASE_URL,
    REACT_APP_API_ENDPOINT_CACHED,
    COMMUNITY_USER_PROFILE,
    COMMUNITY_SEARCH_CONTENT,
    COMMUNITY_USER_ONBOARDING_SEED,
};
